import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { processReq } from "../../helpers/processRequest";
import { GET, POST, PUT, DELETE } from "../../utils/requestActionConstants";
import { API_ROUTE } from "../../utils/commonConstants";

const init = {
    review: {},
    reviewList: [],
    loading: {},
    error: null
};

export const reviewSlice = createSlice({
    name: "reviewSlice",
    initialState: init,
    reducers: {
        setReview: (state, action) => {
            state.review = action.payload;
        },

        setReviews: (state, action) => {
            state.reviewList = action.payload;
        },

        clearData: (state) => {
            return init;
        },
    },
    extraReducers: (builder) => {
        builder
        // Fetch data list
        .addCase(fetchReviewList.pending, (state) => {
            state.loading.fetching = true;
            state.error = null;
        })
        .addCase(fetchReviewList.fulfilled, (state, action) => {
            state.loading.fetching = false;
            state.reviewList = action.payload;
        })
        .addCase(fetchReviewList.rejected, (state, action) => {
            state.loading.fetching = false;
            state.error = action.payload;
        })

        // Add review
        .addCase(addReview.pending, (state) => {
            state.loading.saving = true;
            state.error = null;
        })
        .addCase(addReview.fulfilled, (state, action) => {
            state.loading.saving = false;
            state.review = action.payload;
        })
        .addCase(addReview.rejected, (state, action) => {
            state.loading.saving = false;
            state.error = action.payload;
        })

        // Update review
        .addCase(updateReview.pending, (state) => {
            state.loading.saving = true;
            state.error = null;
        })
        .addCase(updateReview.fulfilled, (state, action) => {
            state.loading.saving = false;
            state.review = action.payload;
        })
        .addCase(updateReview.rejected, (state, action) => {
            state.loading.saving = false;
            state.error = action.payload;
        });;
    }
});

export const fetchReviewList = createAsyncThunk(
    "reviewSlice/fetchReviewList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await processReq(GET, `${API_ROUTE}/reviews`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to fetch data");
        }
    }
);

export const updateReview = createAsyncThunk(
    "reviewSlice/updateReview",
    async ({ reviewId, reviewData }, { rejectWithValue, dispatch }) => {
        try {
            const response = await processReq(PUT, `${API_ROUTE}/reviews/${reviewId}`, reviewData);
            dispatch(fetchReviewList());
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to update review");
        }
    }
);

export const addReview = createAsyncThunk(
    "reviewSlice/addReview",
    async ({ reviewData }, { rejectWithValue, dispatch }) => {
        try {
            const response = await processReq(POST, `${API_ROUTE}/reviews`, reviewData);
            dispatch(fetchReviewList());
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to add review");
        }
    }
);

export const deleteReview = createAsyncThunk(
    "reviewSlice/deleteReview",
    async ({ reviewId }, { rejectWithValue, dispatch }) => {
        try {
            const response = await processReq(DELETE, `${API_ROUTE}/reviews/${reviewId}`);
            dispatch(fetchReviewList());
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to delete review");
        }
    },
);

export const { clearData, setReview, setReviews } = reviewSlice.actions;

export default reviewSlice.reducer;
